import { render, staticRenderFns } from "./ResultadosC3Section.vue?vue&type=template&id=46a5f90f&scoped=true"
import script from "./ResultadosC3Section.vue?vue&type=script&lang=js"
export * from "./ResultadosC3Section.vue?vue&type=script&lang=js"
import style0 from "./ResultadosC3Section.vue?vue&type=style&index=0&id=46a5f90f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a5f90f",
  null
  
)

export default component.exports